import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import AuthApi from "../../api/auth";
import routes from '../../utils/routes';
import toast from 'react-hot-toast';
import * as Yup from "yup";
import getAppData from "../../appInit/appDataApi"
import { ErrorMessage, Field, Form, Formik } from "formik";
import socketConnection from '../../socket/socketConnection';

let validationSchema = Yup.object({
   email: Yup.string()
      .required("Email is Required.")
      .email("Email is not valid."),
   password: Yup.string()
      .required("Password is Required.")
      .min(6, "Must be greater then 6 characters."),
});

let Login = () => {
   let navigate = useNavigate();
   let [passwordView, setPasswordView] = useState(false)

   useEffect(() => {
      const token = localStorage.getItem("token");
      if (token) {
         navigate(routes.dashboard);
      }
   }, [])


   return (
      <div className='bg-global'>
         <div className="container">
            <div className="row">
               <div className="col-12">
                  <div className="authContainerWrapper">
                     <div>
                        <h2 className="font-xxl pb-3">Login</h2>
                        <Formik
                           initialValues={{
                              email: "",
                              password: "",
                           }}
                           validationSchema={validationSchema}
                           onSubmit={async (values, { setSubmitting }) => {
                              setSubmitting(true);
                              try {
                                 let res = await AuthApi.login(values)
                                 if (res.status == 200) {
                                    localStorage.setItem("token", res?.data?.data?.token);
                                    localStorage.setItem("profile", JSON.stringify(res?.data?.data));
                                    toast.success('Login successfully.');
                                    socketConnection.emit("login", res?.data?.data?._id);
                                    getAppData();
                                    navigate(routes.dashboard);
                                 }
                                 setSubmitting(false);
                              } catch (error) {
                                 console.log(error.message);
                                 setSubmitting(false);
                              }
                           }}
                        >
                           {({ isSubmitting, values, errors }) => (
                              <Form>
                                 <div className="form-group">
                                    <label>Email Address</label>
                                    <Field
                                       name="email"
                                       className="form-control rounded"
                                       placeholder="Info@example.com"
                                    />
                                    <ErrorMessage component="small" className='text-danger' name="email" />
                                 </div>
                                 <div className="form-group display-password">
                                    <label>Password</label>
                                    <Field
                                       autoComplete="password"
                                       id="password"
                                       type={passwordView ? "text" : "password"}
                                       name="password"
                                       className="form-control input-bg rounded pe-4"
                                       placeholder="*******"
                                    />
                                    <div className='password-view' onClick={() => setPasswordView(!passwordView)}>
                                       {passwordView ? <i className='fas fa-eye  '></i> : <i className='fas fa-eye-slash'></i>}
                                    </div>
                                    <ErrorMessage component="small" className='text-danger' name="password" />
                                 </div>
                                 <div className="form-group form-check py-3 text-end">
                                    <Link exact="true" to="/reset-password" className=" font-bold">Forget Password?</Link>
                                 </div>
                                 <small className="my-3 text-danger">
                                    {/* <p>{ApiError}</p> */}
                                 </small>
                                 <div className="p-0 mt-2 text-left col-sm-12">
                                    <div className="mb-1 form-group">
                                       <button type="submit" disabled={isSubmitting} className="w-100 rounded-0 btn btn-dark">{isSubmitting ? "Loading..." : "Login"}</button>
                                    </div>
                                 </div>
                              </Form>
                           )}
                        </Formik>
                        <br />
                        <p>
                           New Here?
                           <Link exact="true" to='/register'>
                              <span className="font-bold"> Create an Account</span>
                           </Link>
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default Login